import { SchedulesInInboxBase } from "@/protocols/schedule"
import ApiService from "@/services/Api"

type ScheduleSnoozeRequest = {
	inboxChannelChatId: number
	snoozeId: number
	userId: number
	snoozeNote: string | null
	snoozeTimeInMilliseconds: string
}

class ScheduleService {
	async scheduleSnooze (input: ScheduleSnoozeRequest): Promise<SchedulesInInboxBase> {
		const {
			inboxChannelChatId,
			snoozeId,
			snoozeNote,
			snoozeTimeInMilliseconds,
			userId
		} = input

		const response = await ApiService.post("/schedules/snooze/handle", {
			callback: {
				type: "webhook"
			},
			payload: {
				inboxChannelChatId,
				snoozeId,
				snoozeNote,
				userId
			},
			time: snoozeTimeInMilliseconds,
			timeType: "date-by-now-in-milliseconds"
		})

		return response.data
	}
}

export default new ScheduleService()
